import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { useTenant } from '@/contexts/TenantContext';

export default function TenantDashboard() {
  const { t } = useTranslation();
  const { selectedTenant } = useTenant();
  const { user } = useAuth();

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6">
      <div className="space-y-2">
        <h1 className="text-2xl font-bold text-gray-900">{t('common.dashboard')}</h1>
        <p className="text-gray-500">
          {selectedTenant?.name} ({selectedTenant?.id})
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>{t('sidebar.myAccount')}</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-sm">
              <p className="font-medium">{user?.name}</p>
              <p className="text-gray-500">{user?.email}</p>
              <p className="text-xs text-gray-400 mt-1 uppercase">{user?.role}</p>
            </div>
          </CardContent>
        </Card>

        <Card className="md:col-span-2">
          <CardHeader>
            <CardTitle>{t('menu.announcements')}</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="border-l-4 border-blue-500 pl-4 py-1 bg-blue-50 rounded-r">
                <span className="text-xs font-bold text-blue-600">2026-01-19</span>
                <p className="text-sm font-medium text-gray-900">System maintenance scheduled for next weekend.</p>
              </div>
              <div className="border-l-4 border-gray-300 pl-4 py-1 bg-gray-50 rounded-r">
                <span className="text-xs font-bold text-gray-500">2026-01-15</span>
                <p className="text-sm font-medium text-gray-900">
                  Release v1.2.0: Added Exam Hall Management features.
                </p>
              </div>
              <div className="border-l-4 border-gray-300 pl-4 py-1 bg-gray-50 rounded-r">
                <span className="text-xs font-bold text-gray-500">2026-01-10</span>
                <p className="text-sm font-medium text-gray-900">Welcome to the new Admission Platform!</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
